import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardLayoutComponent, CardItem } from '../shared/card-layout/card-layout.component';
import { Store } from '@ngrx/store';
import { globalMessages } from '../shared/global-messages';

@Component({
    selector: 'app-claims',
    imports: [CommonModule, CardLayoutComponent],
    template: `
        <app-card-layout
            (click)="isActive = !isActive"
            [isActive]="isActive"
            title="Claims"
            [isLoading]="isClaimsLoaded"
            [failed]="claimsFailed"
            [items]="claims"
            [noDataMessage]="globalMessages.noDataAvailabelMsg"
            (retry)="retryClaims()"
        ></app-card-layout>
    `,
})
export class ClaimsComponent {
    isActive = false;
    @Input() isClaimsLoaded = false;
    @Input() claimsFailed = false;
    @Output() retry = new EventEmitter<void>();
    private store = inject(Store);
    policySignal = this.store.selectSignal((state: any) => state.policy);
    globalMessages = globalMessages;

    get claims(): CardItem[] {
        const policyState = this.policySignal();
        const policyNum = policyState.policyNumber;
        const data: any[] = policyState.data?.[policyNum]?.claimsSnapshot?.claims;
        if (!data || !Array.isArray(data) || data.length === 0) return [];
        return data.map((claim: any, index: number) => ({
            label: 'Claim',
            title: `Claim (${index + 1})`,
            icon: 'claims-icon',
            fields: [
                { caption: 'Type of Loss', value: claim.typeofloss || '-' },
                { caption: 'Cause of Loss', value: claim.causeofloss || '-' },
                { caption: 'Loss Date', value: claim.lossdate || '-' },
                { caption: 'Loss Reported Date', value: claim.lossreporteddate || '-' },
                { caption: 'Loss Amount', value: claim.lossamount || '-' },
                { caption: 'Loss Status', value: claim.lossStatus || '-' },
                { caption: 'Source', value: claim.source || '-' },
            ],
        }));
    }

    retryClaims() {
        this.retry.emit();
    }
}
